<template>
  <section class="anamnesis-observations">

    <div class="d-flex justify-content-between flex-wrap align-items-center">
      <h6 class="text-evollu-gray-light is-bold py-3">
          {{$t('clinical.people.anamnesis.obs')}}
      </h6>
      <i 
        v-if="collapsable" 
        class="clickable p-3"
        :class="{'fa fa-chevron-up': !isCollapsed, 'fa fa-chevron-down': isCollapsed}"
        @click="isCollapsed = !isCollapsed"
      >
      </i>
    </div>

    <div>
      <form class="evollu-form">

        <slot name="beforeForm"></slot>
        
        <div class="row align-items-start">
          <label class="is-bold col-12 col-sm-5 col-md-4 mb-0 text-sm-right">
            {{$t('clinical.people.anamnesis.general_obs')}}
          </label>
          
          <div class="col-12 col-sm-7 col-md-8 col-lg-7 col-xl-6">
            <va-input
              id="anamnesis-observations"
              type="textarea"
              :min-rows="3"
              :placeholder="$t('clinical.people.anamnesis.general_obs')"
              :value="value"
              @input="v => updateValue('anamnesis_obs', v)"
              :error="formErrors.has('anamnesis_obs')"
              :error-messages="[$t(formErrors.get('anamnesis_obs'))]"
              :disabled="!editing"
            />
          </div>
        </div>

      </form>
    </div>
  </section>
</template>

<script>
import Errors from '@/utils/StandardErrors'
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    formErrors: {
      type: Object,
      required: false,
      default: () => {
        return new Errors()
      }
    },
    editing: {
      type: Boolean,
      default: true
    },
    collapsable: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isCollapsed: this.collapsable && this.collapsed,
    }
  },
  methods: {
    updateValue: function (field, value) {
      this.$emit('input', value)
      this.$emit('clearErrors', field)
    }
  },
  watch: {
    collapsed: function () {
      this.isCollapsed = this.collapsable && this.collapsed
    },
    editing: {
      handler: function (editing) {
        if (editing) {
          this.$emit('input', this.value)
        }
      },
      immediate: true
    }
  }
}
</script>